<template>
  <div class="app-container">
    <!--    <div class="topbar">-->
    <!--      <div>-->
    <!--        <el-input v-model="searchValue" size="small" placeholder=""-->
    <!--                  prefix-icon="el-icon-search" class="search-input" @keyup.enter.native="search()"/>-->
    <!--        <el-button type="primary" icon="el-icon-search" size="small" :disabled="!searchValue"-->
    <!--                   @click.stop="search()">-->
    <!--          搜索-->
    <!--        </el-button>-->
    <!--      </div>-->

    <!--    </div>-->

    <el-table :data="tableData" v-loading="loading" :header-cell-style="{ background: '#F5F7FA' }"
              style="width: 100%; margin-bottom: 20px" border>

      <el-table-column align="center" property="creditOrderId" label="#"/>
      <el-table-column align="center" property="creditValue" label="已支付"/>
      <el-table-column align="center" property="payer" label="支付者" show-overflow-tooltip>
        <template #default="scope">
          <user-info :user="scope.row"></user-info>
        </template>
      </el-table-column>
      <el-table-column align="center" property="createTime" label="支付时间">
        <template #default="scope">
          {{ scope.row.createTime |formatDateTime }}
        </template>
      </el-table-column>

    </el-table>
    <el-pagination background :total="totalCount" :page-size="pageSize"
                   :current-page="currentPage" @current-change="currentChange"/>
  </div>
</template>

<script>
import {getLiveReviewCreditOrderList} from "@/api/mai/liveReviews/liveReviews";
import {handleRes} from "@/utils/handleRes";
import UserInfo from "@/components/UserInfo/UserInfo";

export default {
  name: "CreditOrderList",
  components: {UserInfo},
  props: {
    liveID: {
      Number
    }
  },
  data() {
    return {
      loading: false,
      searchValue: "",
      tableData: [],
      totalCount: 0, // 列表总数
      pageSize: 10, // 单页条数
      currentPage: 1, // 当前页码
    }
  },
  created() {
    this.getLiveReviewCreditList()
  },
  methods: {
    getLiveReviewCreditList() {
      let params = {
        keyWord: this.searchValue,
        liveId: this.liveID,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
      }
      this.replyLoading = true;
      getLiveReviewCreditOrderList(params).then((res) => {
        handleRes(res, () => {
          this.tableData = res.data.rows
          this.totalCount = res.data.total
        })
        this.utils.stopLoading(this)
      })
    },
    search() {
      this.refreshList()
    },
    currentChange(curPage) {
      this.currentPage = curPage
      this.getLiveReviewCreditList()
    },
    refreshList() {
      this.currentPage = 1
      this.getLiveReviewCreditList()
    },
  }
}
</script>

<style scoped>

</style>